import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  useRailsApp,
} from "@bleu.builders/ui";
import { TicketX } from "lucide-react";
import React from "react";

export const CancelPlanConfirmation = ({ organization }) => {
  const { csrfToken } = useRailsApp();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" className="w-full">
          <TicketX size={16} className="mr-2" />
          Cancelar assinatura
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Voce tem certeza?</AlertDialogTitle>
          <AlertDialogDescription>
            Uma vez cancelada a assinatura, o usuário terá que se inscrever de
            novo.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Sair</AlertDialogCancel>
          <form
            action={`/admin/organizations/${organization.id}/cancel_subscription`}
            method="post"
          >
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <Button variant="destructive" type="submit">
              Confirmar cancelamento
            </Button>
          </form>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
